import axios from '@/plugins/axios'
import { Message } from 'element-ui'

export default {
  namespaced: true,

  state: {
    loading: false,
    artists: [],
    labels: [],
    dialog: false,
    dialog_type: '',
    page: 1,
    page_size: 10,
    order_column: 'artist.name',
    order_type: 'asc',
    step: 1,
    artist_id: null,
    metadata: {
      name: '',
      biography: '',
      quote: '',
      press: '',
      hashtags: '',
      link_fire: '',
      youtube_video: '',
      active: null,
      label: null,
      featured: '',
      focus: '',
      spotlight: ''
    },
    social: {},
    socials: {},
    image: null
  },

  mutations: {
    setArtists(state, payload) {
      state.artists = payload
    },
    setMetadata(state, payload) {
      if (payload.social) {
        const yt_video = payload.social.filter(
          soc => soc.type.name.toLowerCase() === 'music video link'
        )
        if (yt_video.length > 0) {
          payload.youtube_video = yt_video[0].url
        } else payload.youtube_video = ''
      } else payload.youtube_video = ''

      state.metadata = payload
    },
    setSocial(state, payload) {
      state.social = payload
    },
    setSocials(state, payload) {
      state.socials = payload
    },
    setImage(state, payload) {
      state.image = payload
    },
    setStep(state, payload) {
      state.step = payload
    },
    setArtistID(state, payload) {
      state.artist_id = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setDialog(state, { status, type }) {
      state.dialog = status
      state.dialog_type = type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setLabels(state, payload) {
      state.labels = payload
    }
  },

  actions: {
    read({ commit, state }, filters = null) {
      commit('setLoading', true)

      let ls = localStorage.getItem('artist_new_releases_filter')
      filters = JSON.parse(ls)

      axios.admin
        .get('talent-scout/artist', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            ...filters
          }
        })
        .then(r => {
          commit('setArtists', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    readSocials({ commit }, id) {
      commit('setLoading', true)
      axios.admin
        .get(`talent-scout/artist/${id}/social`)
        .then(r => {
          let obj = {}
          r.data.data.forEach(s => {
            switch (s.social_type_fk) {
              case 1:
                obj['website'] = s.url
                break
              case 2:
                obj['youtube_video'] = s.url
                break
              case 3:
                obj['youtube_channel'] = s.url
                break
              case 4:
                obj['instagram'] = s.url
                break
              case 5:
                obj['facebook'] = s.url
                break
              case 6:
                obj['tiktok'] = s.url
                break
              case 7:
                obj['spotify'] = s.url
                break
              case 8:
                obj['apple_music'] = s.url
                break
              case 9:
                obj['amazon'] = s.url
                break
              case 10:
                obj['deezer'] = s.url
                break
              case 11:
                obj['soundcloud'] = s.url
                break
              case 12:
                obj['twitter'] = s.url
                break
              case 13:
                obj['bandcamp'] = s.url
                break
              case 14:
                obj['other'] = s.url
                break
              case 15:
                obj['music_video_2'] = s.url
                break
              case 16:
                obj['music_video_3'] = s.url
                break
              case 17:
                obj['music_video_4'] = s.url
                break
            }
          })
          commit('setSocials', obj)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    async createMetadata({ dispatch, commit, state }) {
      return await axios.admin
        .post('talent-scout/artist', {
          name: state.metadata.name,
          biography: state.metadata.biography,
          quote: state.metadata.quote,
          press: state.metadata.press,
          hashtags: state.metadata.hashtags,
          active: state.metadata.active,
          youtube_video: state.metadata.youtube_video,
          label: state.metadata.label,
          featured: state.metadata.featured,
          focus: state.metadata.focus,
          spotlight: state.metadata.spotlight
        })
        .then(r => {
          commit('setArtistID', r.data.data.artist_id)
          commit('setDialog', false)
          commit('setStep', 2)
          dispatch('updateSocial', r.data.data.artist_id)
        })
    },

    createSocial({ dispatch, commit, state }) {
      axios.admin
        .post('talent-scout/artist/social', {
          id: state.artist_id,
          social: state.social
        })
        .then(() => {
          dispatch('read', {
            page: state.page,
            page_size: state.page_size
          })
          commit('setDialog', false)
          commit('setStep', 3)
        })
    },

    /*createImage({ dispatch, commit, state }) {
      axios.admin
        .post(`talent-scout/artist/${state.artist_id}/image`, {
          images: state.images
        })
        .then(() => {
          dispatch('read', {
            page: state.page,
            page_size: state.page_size
          })
          commit('setDialog', false)
          commit('setStep', 1)
        })
    },*/

    publishArtist({ dispatch, state }, id) {
      axios.admin.put('talent-scout/artist/publish/' + id).then(() => {
        dispatch('read', {
          page: state.page,
          page_size: state.page_size
        })
      })
    },

    unpublishArtist({ dispatch, state }, id) {
      axios.admin.put('talent-scout/artist/unpublish/' + id).then(() => {
        dispatch('read', {
          page: state.page,
          page_size: state.page_size
        })
      })
    },

    uploadImage({ dispatch, commit, state }, image) {
      axios.admin.post('talent-scout/artist/image', image).then(r => {
        dispatch('read', {
          page: state.page,
          page_size: state.page_size
        })
        commit('setImage', r.data.response.message)
      })
    },

    getImage({ commit }, id) {
      commit('setLoading', true)
      axios.admin
        .get(`talent-scout/artist/${id}/image`)
        .then(r => {
          commit('setImage', r.data.data[0].file_name)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
          commit('setImage', null)
        })
    },

    updateMetadata({ commit, state }, id) {
      axios.admin
        .put(`talent-scout/artist/${id}/metadata`, {
          name: state.metadata.name,
          biography: state.metadata.biography,
          quote: state.metadata.quote,
          press: state.metadata.press,
          hashtags: state.metadata.hashtags,
          active: state.metadata.active,
          label: state.metadata.label,
          youtube_video: state.metadata.youtube_video,
          featured: state.metadata.featured,
          focus: state.metadata.focus,
          spotlight: state.metadata.spotlight
        })
        .then(() => {
          commit('setDialog', false)
        })
        .catch(err => {
          console.log(err.response.data)
          if (err.response.data && err.response.data.message) {
            Message({
              type: 'error',
              message: err.response.data.message
            })
            commit('setDialog', false)
          }
        })
    },

    updateSocial({ dispatch, state }, id) {
      axios.admin
        .put(`talent-scout/artist/${id}/social`, {
          social: state.socials
        })
        .then(() => {
          dispatch('read', {
            page: state.page,
            page_size: state.page_size
          })
        })
    },

    checkArtist({ commit }, name = null) {
      commit('setLoading', true)
      axios.admin
        .get('talent-scout/artist', {
          params: {
            full_name: name
          }
        })
        .then(r => {
          if (r.data.data.data.length > 0) {
            Message({
              type: 'error',
              message: 'Artist already exist'
            })
          }
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    getLabel({ commit }) {
      commit('setLoading', true)
      axios.admin
        .get('talent-scout/label', {
          params: {
            no_paginate: 1
          }
        })
        .then(r => {
          commit('setLabels', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    }
  }
}
